import React, { ReactElement } from 'react';
import FilterContainer from '../../../../../components/filter-container/filter-container.component';
import FilterDateField from '../../../../../components/filter-date-field/filter-date-field.component';
import DateService from '../../../../../services/date-service';
import { FILTER_VALUE_EMPTY } from '../../../../../constants/system/filter-values';
import { FILTER_TYPE_CREATE_DATE_FROM, FILTER_TYPE_CREATE_DATE_TO } from '../../../../../constants/system/filter-types';

const SettingsErrorMessageListFilters: ReactMemoComponent = React.memo((
  props: ReactComponentProps,
): ReactElement => {
  const {
    currentFilters,
    filterErrorMap,
    onSetFilterValue,
    onFilterError,
  } = props;

  return (
    <FilterContainer>
      <FilterDateField
        filterType={FILTER_TYPE_CREATE_DATE_FROM}
        label="Date From"
        value={(currentFilters[FILTER_TYPE_CREATE_DATE_FROM]
          && DateService.parseDate(currentFilters[FILTER_TYPE_CREATE_DATE_FROM])) || FILTER_VALUE_EMPTY}
        filterErrorMap={filterErrorMap}
        currentFilters={currentFilters}
        onSetFilterValue={onSetFilterValue}
        onFilterError={onFilterError}
      />
      <FilterDateField
        filterType={FILTER_TYPE_CREATE_DATE_TO}
        label="Date To"
        value={(currentFilters[FILTER_TYPE_CREATE_DATE_TO]
          && DateService.parseDate(currentFilters[FILTER_TYPE_CREATE_DATE_TO])) || FILTER_VALUE_EMPTY}
        filterErrorMap={filterErrorMap}
        currentFilters={currentFilters}
        onSetFilterValue={onSetFilterValue}
        onFilterError={onFilterError}
      />
    </FilterContainer>
  );
});

export default SettingsErrorMessageListFilters;
